import { render, staticRenderFns } from "./PhonesGraphs.vue?vue&type=template&id=02354743&scoped=true"
import script from "./PhonesGraphs.vue?vue&type=script&lang=ts"
export * from "./PhonesGraphs.vue?vue&type=script&lang=ts"
import style0 from "./PhonesGraphs.vue?vue&type=style&index=0&id=02354743&prod&lang=scss&scoped=true"
import style1 from "./PhonesGraphs.vue?vue&type=style&index=1&id=02354743&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02354743",
  null
  
)

export default component.exports